import { createContext } from '@shared/utils/createContext';
import React, { useCallback, useState } from 'react';
import { useDisclosure } from '@withjoy/joykit';

type MobileProductQuickAddDrawerContext = {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  handleChangeCurrentProductId: (productId: string) => void;
  handleChangeCurrentProductIndex: (index: number) => void;
  currentProductId: Maybe<string>;
  currentProductIndex: Maybe<number>;
};

const [Provider, useMobileProductQuickAddDrawerProvider] = createContext<MobileProductQuickAddDrawerContext>({
  name: 'MobileProductQuickAddDrawerProvider'
});

interface MobileProductQuickAddDrawerProps
  extends Readonly<{
    children: React.ReactNode;
  }> {}

const MobileProductQuickAddDrawerProvider = (props: MobileProductQuickAddDrawerProps) => {
  const { children } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentProductId, setCurrentProductId] = useState<Maybe<string>>(null);
  const [currentProductIndex, setCurrentProductIndex] = useState<Maybe<number>>(null);

  const openDrawer = useCallback(() => {
    onOpen();
  }, [onOpen]);

  const closeDrawer = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleChangeCurrentProductId = useCallback(
    (productId: string) => {
      setCurrentProductId(productId);
    },
    [setCurrentProductId]
  );

  const handleChangeCurrentProductIndex = useCallback(
    (index: number) => {
      setCurrentProductIndex(index);
    },
    [setCurrentProductIndex]
  );

  return (
    <Provider
      value={{
        isOpen,
        currentProductId,
        currentProductIndex,
        openDrawer,
        closeDrawer,
        handleChangeCurrentProductId,
        handleChangeCurrentProductIndex
      }}
    >
      {children}
    </Provider>
  );
};

MobileProductQuickAddDrawerProvider.displayName = 'MobileProductQuickAddDrawerProvider';

export { MobileProductQuickAddDrawerProvider, useMobileProductQuickAddDrawerProvider };
